import script from "./BookingMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingMenu.vue?vue&type=script&setup=true&lang=ts"

import "./BookingMenu.vue?vue&type=style&index=0&id=29381cbe&lang=scss"

const __exports__ = script;

export default __exports__